import { create } from 'zustand'

interface LoadingState {
  /** Task aktif: key ➝ label yang ditampilkan. */
  tasks: Record<string, string>
  begin: (key: string, label: string) => void
  end: (key: string) => void
}

export const useLoadingStore = create<LoadingState>((set) => ({
  tasks: {},
  begin: (key, label) =>
    set((state) => ({ tasks: { ...state.tasks, [key]: label } })),
  end: (key) =>
    set((state) => {
      const next = { ...state.tasks }
      delete next[key]
      return { tasks: next }
    }),
}))

/**
 * Membungkus operasi async apa pun agar indikator loading global
 * ikut menyala selama proses berjalan.
 */
export async function withGlobalLoading<T>(
  key: string,
  label: string,
  run: () => Promise<T>,
): Promise<T> {
  useLoadingStore.getState().begin(key, label)
  try {
    return await run()
  } finally {
    useLoadingStore.getState().end(key)
  }
}
